import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { environment } from '@environment';
import { ConfigService } from 'src/app/_services/config.service';
import { Unit } from '../../../../_models/user/unit';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UnitService {
  private readonly unitUrl = this.environment.commonUtilityApi.baseUrl + this.environment.commonUtilityApi.units;
  private _units = new BehaviorSubject<Unit[]>(null)
  private _verboseUnits = new BehaviorSubject<Unit[]>(null)
  constructor(private http: HttpClient, private environment: ConfigService) {
  }

  getUnitsByGacc(gacc: string, limit: number = 10000, nameOnly: boolean = false, offset: number = 0) {
    const unitUrlWithParams = `${this.unitUrl}?gacc=${gacc}&limit=${limit}&nameOnly=${nameOnly}&offset=${offset}`
    return this.http.get<Unit[]>(unitUrlWithParams);
  }

  getUnits() {
    const unitMap = new Map();
    if(this._units.value == null){
      return this.http.get<Unit[]>(`${this.unitUrl}?limit=10000&nameOnly=true&offset=0`).pipe(
        tap((units)=>{
          this._units.next(units)
        })
      );
    } else {
      return this._units.asObservable()
    }
  }
  getUnitByIrwinId(irwinId: string) {
    return this.http.get<Unit>(`${this.environment.commonUtilityApi.baseUrl}/unitByUnitIrwinId/${irwinId}`);
  }

  getVerboseUnits(){
    if(this._verboseUnits.value == null){
      return this.http.get<Unit[]>(`${this.unitUrl}?limit=10000&nameOnly=false&offset=0`).pipe(
        tap((units)=>{
          this._verboseUnits.next(units)
        })
      );
    } else {
      return this._units.asObservable()
    }
  }
}
